import {
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db} from "../assets/Firebase";
import { uploadToCloudinary } from "../assets/Cloudinary";


export async function fetchCurrentUserDetails(userId) {
  try {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);
    let userDetails = null;
    if (docSnap.exists()) {
      userDetails = { userId: docRef.id, ...docSnap.data() };
    }
    return userDetails;
  } catch (error) {
    throw error;
  }
}

export async function isUserNameAvialable(userName, myUserName) {
  if (userName.trim() === myUserName) return true;
  try {
    const querySnapshot = await getDocs(
      query(collection(db, "users"), where("userName", "==", userName.trim()))
    );
    return querySnapshot.empty;
  } catch (error) {
    throw error;
  }
}

export async function saveProfilePhoto(profilePhoto, userId) {
  try {
    const url = await uploadToCloudinary(
      profilePhoto,
      userId,
      "users"
    );
    return url;
  } catch (error) {
    throw error;
  }
}

export async function updateProfile(userId, updatedProfile) {
  try {
    const docRef = doc(db, "users", userId);
    await updateDoc(docRef, updatedProfile);
    const updatedDoc = await getDoc(docRef);
    return { userId, ...updatedDoc.data() };
  } catch (error) {
    throw error;
  }
}

export async function fetchSuggestedUser({ following }) {
  try {
    const currentUserId = auth.currentUser.uid;
    const usersCollection = collection(db, "users");

    const usersQuery = query(
      usersCollection,
      where("__name__", "not-in", [currentUserId, ...following]),
      orderBy("__name__"),
      limit(10)
    );

    const querySnapshot = await getDocs(usersQuery);
    const otherUsers = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      otherUsers.push({
        id: doc.id,
        userName: data.userName || "",
        fullName: data.fullName || "",
        profilePhoto: data.profilePhoto || ""
      });
    });

    return otherUsers;
  } catch (error) {
    throw error;
  }
}
export async function followUser(userId,userTofollow) {
  try {
    const docRefHost = doc(db, "users", userId);
    const docRefUser = doc(db,"users",userTofollow)
    await updateDoc(docRefHost, {
      following: arrayUnion(userTofollow),
    });

    await updateDoc(docRefUser,{
      followers:arrayUnion(userId)
    })
    
  } catch (error) {
    throw error;
  }
}

export async function unfollowUser(userId, userToUnfollow) {
  try {
    const docRefHost = doc(db, "users", userId);
    const docRefUser = doc(db,"users",userToUnfollow);
    await updateDoc(docRefHost, {
      following: arrayRemove(userToUnfollow),
    });

    await updateDoc(docRefUser,{
      followers:arrayRemove(userId)
    })
  } catch (error) {
    throw error;
  }
}

export async function removeUser(userId,userToRemove){
  try {

    const docRefHost = doc(db, "users", userId);
    const docRefUser = doc(db,"users",userToRemove);
    await updateDoc(docRefHost, {
      followers: arrayRemove(userToRemove),
    });

    await updateDoc(docRefUser,{
      following:arrayRemove(userId)
    })
  } catch (error) {
    throw error;
  }
}

export async function addToBookmark(userId, postId) {
  try {
    const docRef = doc(db, "users", userId);
    await updateDoc(docRef, {
      bookmarks: arrayUnion(postId),
    });
  } catch (error) {
    throw error;
  }
}

export async function removeFromBookmark(userId, postId) {
  try {
    const docRef = doc(db, "users", userId);
    await updateDoc(docRef, {
      bookmarks: arrayRemove(postId),
    });
  } catch (error) {
    throw error;
  }
}

export async function fetchUserBasicInfo(userId) {
  try {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);
    let userDetails = null;
    if (docSnap.exists()) {
      const { userName, profilePhoto,fullName } = docSnap.data();
      userDetails = { userName, profilePhoto,fullName };
    }
    return userDetails;
  } catch (error) {
    throw error;
  }
}

export async function fetchAllUsers(){
  const usersCollection = collection(db, 'users');
  const querySnapshot = await getDocs(usersCollection);
  const allUsers=[];
  querySnapshot.forEach((doc) => {
    allUsers.push({userId:doc.id,fullName:doc.data().fullName,userName:doc.data().userName});
  });
  return allUsers
}
